export const recommendations = [
  {
    id: "rec-01",
    title: "鬼灭之刃 无限城篇",
    subtitle: "热血斩鬼的巅峰对决",
    genre: "战斗",
    tags: ["战斗", "奇幻", "热血"],
    summary:
      "以华丽的剑技与强烈的色彩表现著称的战斗番。本季延续高密度的动作演出与人物羁绊，适合喜欢快节奏、强情绪释放的观众。",
    episodes: "全 12 话",
    score: "9.0",
    status: "连载中",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20poster%20of%20a%20young%20swordsman%20in%20a%20dark%20patterned%20coat%20holding%20a%20glowing%20crimson%20blade%2C%20dramatic%20night%20scene%20with%20swirling%20flame%20effects%20and%20falling%20sparks%2C%20deep%20red%20and%20charcoal%20palette%2C%20cinematic%20action%20composition%2C%20painterly%20anime%20illustration%20style%2C%20detailed%20shading%2C%20simple%20dark%20atmospheric%20background&width=600&height=800&seq=anime-rec-01&orientation=portrait",
    alt: "鬼灭之刃风格热血斩鬼动漫主视觉插画",
  },
  {
    id: "rec-02",
    title: "咒术回战",
    subtitle: "诅咒与信念的拉扯",
    genre: "战斗",
    tags: ["战斗", "超自然", "暗黑"],
    summary:
      "以诅咒与咒术为设定骨架的现代战斗番，分镜凌厉、情绪张力强。本季聚焦角色之间的立场冲突与成长代价，节奏紧凑。",
    episodes: "全 24 话",
    score: "8.9",
    status: "连载中",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20poster%20of%20a%20white%20haired%20student%20sorcerer%20in%20dark%20uniform%20channeling%20glowing%20curse%20energy%2C%20moody%20teal%20and%20black%20sky%20with%20floating%20embers%2C%20bold%20graphic%20shapes%2C%20cinematic%20composition%2C%20painterly%20anime%20illustration%20style%2C%20consistent%20art%20direction%2C%20simple%20dramatic%20dark%20background&width=600&height=800&seq=anime-rec-02&orientation=portrait",
    alt: "咒术回战风格超自然战斗动漫主视觉插画",
  },
  {
    id: "rec-03",
    title: "葬送的芙莉莲",
    subtitle: "漫长旅途中的温柔告别",
    genre: "奇幻",
    tags: ["奇幻", "治愈", "冒险"],
    summary:
      "以时间跨度与人物回忆为核心的奇幻作品，用缓慢的旅途敘事探讨告别与陪伴。画面精致，情绪克制却后劲十足。",
    episodes: "全 28 话",
    score: "9.4",
    status: "已完结",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20poster%20of%20a%20silver%20haired%20elf%20mage%20in%20a%20white%20robe%20holding%20a%20wooden%20staff%2C%20serene%20meadow%20with%20distant%20mountains%20and%20drifting%20petals%2C%20soft%20warm%20golden%20light%2C%20gentle%20fantasy%20atmosphere%2C%20painterly%20anime%20illustration%20style%2C%20consistent%20art%20direction%2C%20simple%20open%20sky%20background&width=600&height=800&seq=anime-rec-03&orientation=portrait",
    alt: "葬送的芙莉莲风格奇幻治愈动漫主视觉插画",
  },
  {
    id: "rec-04",
    title: "迷宫饭",
    subtitle: "地下城里的美食冒险",
    genre: "奇幻",
    tags: ["奇幻", "美食", "冒险"],
    summary:
      "把地下城探索与料理相结合，边冒险边研究魔物食材。轻松的节奏与扎实的世界观细节并存，是很适合放松追的奇幻番。",
    episodes: "全 24 话",
    score: "8.8",
    status: "已完结",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20poster%20of%20a%20warrior%20adventurer%20in%20light%20armor%20exploring%20a%20stone%20dungeon%20corridor%20with%20a%20lantern%2C%20glowing%20mushrooms%20and%20ancient%20carvings%2C%20warm%20amber%20and%20mossy%20green%20palette%2C%20cozy%20fantasy%20adventure%20mood%2C%20painterly%20anime%20illustration%20style%2C%20consistent%20art%20direction%2C%20simple%20dark%20dungeon%20background&width=600&height=800&seq=anime-rec-04&orientation=portrait",
    alt: "迷宫饭风格地下城美食冒险动漫主视觉插画",
  },
  {
    id: "rec-05",
    title: "间谍过家家",
    subtitle: "伪装家庭的欢乐日常",
    genre: "日常",
    tags: ["日常", "搞笑", "治愈"],
    summary:
      "身份各异的三人组成临时家庭，在任务与日常之间制造大量笑点。节奏轻快、氛围温暖，适合下饭或睡前轻松观看。",
    episodes: "全 24 话",
    score: "8.7",
    status: "连载中",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20poster%20of%20a%20cheerful%20spy%20family%20with%20a%20man%20in%20a%20suit%2C%20a%20woman%20in%20a%20red%20dress%20and%20a%20little%20girl%2C%20bright%20cozy%20living%20room%2C%20playful%20warm%20pastel%20tones%2C%20lively%20slice%20of%20life%20composition%2C%20painterly%20anime%20illustration%20style%2C%20consistent%20art%20direction%2C%20simple%20clean%20interior%20background&width=600&height=800&seq=anime-rec-05&orientation=portrait",
    alt: "间谍过家家风格家庭日常动漫主视觉插画",
  },
  {
    id: "rec-06",
    title: "药屋少女的呢喃",
    subtitle: "宫廷里的推理与药香",
    genre: "悬疑",
    tags: ["悬疑", "古风", "推理"],
    summary:
      "以宫廷为舞台，用药学知识与细致观察破解谜团。人物性格鲜明，案件推进有层次，喜欢推理题材的观众会很过瘾。",
    episodes: "全 24 话",
    score: "8.8",
    status: "已完结",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20poster%20of%20an%20elegant%20apothecary%20girl%20in%20traditional%20eastern%20palace%20attire%20holding%20a%20small%20vial%2C%20ornate%20ancient%20palace%20corridor%20with%20red%20pillars%20and%20hanging%20lanterns%2C%20warm%20crimson%20and%20gold%20tones%2C%20mysterious%20courtly%20mood%2C%20painterly%20anime%20illustration%20style%2C%20consistent%20art%20direction%2C%20simple%20palace%20background&width=600&height=800&seq=anime-rec-06&orientation=portrait",
    alt: "药屋少女的呢喃风格古风推理动漫主视觉插画",
  },
  {
    id: "rec-07",
    title: "孤独摇滚！",
    subtitle: "社恐少女的乐队青春",
    genre: "音乐",
    tags: ["音乐", "青春", "日常"],
    summary:
      "以乐队练习与成长为主线，用夸张演出表现社交焦虑的内心世界。笑点密集，音乐段落也足够燃，青春感拉满。",
    episodes: "全 12 话",
    score: "9.2",
    status: "已完结",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20poster%20of%20a%20shy%20girl%20with%20pink%20hair%20playing%20an%20electric%20guitar%20on%20a%20small%20concert%20stage%2C%20colorful%20stage%20lights%20and%20floating%20musical%20notes%2C%20energetic%20youthful%20mood%2C%20vivid%20coral%20and%20amber%20palette%2C%20painterly%20anime%20illustration%20style%2C%20consistent%20art%20direction%2C%20simple%20stage%20background&width=600&height=800&seq=anime-rec-07&orientation=portrait",
    alt: "孤独摇滚风格音乐青春动漫主视觉插画",
  },
  {
    id: "rec-08",
    title: "蓝色监狱",
    subtitle: "极致自我主义的足球",
    genre: "运动",
    tags: ["运动", "热血", "竞技"],
    summary:
      "用极端化的竞技设定塑造前锋群像，比赛场面张力十足。角色目标鲜明，节奏爽快，是运动番中的高能代表。",
    episodes: "全 24 话",
    score: "8.6",
    status: "连载中",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20poster%20of%20a%20determined%20young%20soccer%20player%20in%20a%20blue%20training%20jersey%20striking%20a%20ball%2C%20dynamic%20stadium%20scene%20with%20motion%20streaks%20and%20floodlights%2C%20intense%20sports%20energy%2C%20cool%20blue%20and%20warm%20skin%20tones%2C%20painterly%20anime%20illustration%20style%2C%20consistent%20art%20direction%2C%20simple%20stadium%20background&width=600&height=800&seq=anime-rec-08&orientation=portrait",
    alt: "蓝色监狱风格运动竞技动漫主视觉插画",
  },
];

export const genreFilters = [
  "全部",
  "奇幻",
  "战斗",
  "日常",
  "悬疑",
  "音乐",
  "运动",
];